import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export const PrivacyPage = () => {
    const navigate = useNavigate()

    return (
        <div className="min-h-screen bg-[#0a0a0a] text-gray-300 font-sans p-8 md:p-16">
            <div className="max-w-3xl mx-auto">
                <button
                    onClick={() => navigate('/')}
                    className="flex items-center gap-2 text-orange-500 font-bold mb-8 hover:underline"
                >
                    <ArrowLeft size={20} /> Terug naar Home
                </button>

                <h1 className="text-4xl font-black text-white mb-8">Privacyverklaring</h1>

                <div className="space-y-6 leading-relaxed">
                    <p className="text-sm text-gray-500">Laatst bijgewerkt: 17 december 2025</p>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">1. Inleiding</h2>
                        <p>
                            ProPoule ("wij", "ons") respecteert de privacy van haar gebruikers. In deze privacyverklaring leggen we uit welke persoonsgegevens we verzamelen en hoe we deze gebruiken. Wij verwerken persoonsgegevens in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">2. Gegevens die wij verzamelen</h2>
                        <p>Wij verwerken de volgende persoonsgegevens wanneer je onze dienst gebruikt:</p>
                        <ul className="list-disc pl-6 space-y-2 mt-2">
                            <li>Contactgegevens: Naam, e-mailadres.</li>
                            <li>Accountgegevens: Inloggegevens (beveiligd opgeslagen via Supabase Auth).</li>
                            <li>Betaalgegevens: Transactiehistorie (verwerkt door Stripe, wij slaan geen creditcardnummers op).</li>
                            <li>Gebruiksgegevens: Informatie over toernooien en teams die je aanmaakt.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">3. Doeleinden van de verwerking</h2>
                        <p>Wij gebruiken je gegevens voor:</p>
                        <ul className="list-disc pl-6 space-y-2 mt-2">
                            <li>Het leveren van onze SaaS-dienst (toernooibeheer).</li>
                            <li>Het afhandelen van betalingen en abonnementen.</li>
                            <li>Het verzenden van noodzakelijke service-updates (bijv. wachtwoordherstel).</li>
                            <li>Wettelijke verplichtingen (zoals belastingadministratie).</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">4. Delen met derden</h2>
                        <p>
                            Wij verkopen jouw gegevens nooit door. Wij delen gegevens alleen met noodzakelijke dienstverleners:
                        </p>
                        <ul className="list-disc pl-6 space-y-2 mt-2">
                            <li><strong>Supabase:</strong> Hosting en database provider.</li>
                            <li><strong>Stripe:</strong> Betalingsverwerking.</li>
                            <li><strong>Vercel:</strong> Hosting van de webapplicatie.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-bold text-white mb-3">5. Jouw rechten</h2>
                        <p>
                            Je hebt het recht op inzage, correctie en verwijdering van je gegevens. Je kunt je account en bijbehorende gegevens op elk moment verwijderen via het dashboard. Voor vragen kun je contact opnemen via onderstaande gegevens.
                        </p>
                    </section>

                    <section className="border-t border-white/10 pt-6 mt-8">
                        <h2 className="text-xl font-bold text-white mb-3">Contact</h2>
                        <p>
                            <strong>Clarity Solutions</strong> (handelt onder de naam ProPoule)<br />
                            info@claritysolutions.cloud<br />
                            [Adres & KvK Nummer volgen na inschrijving]
                        </p>
                    </section>
                </div>
            </div>
        </div>
    )
}
